import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import './libs/bulma-0.9.4/bulma/css/bulma.min.css';
import './libs/fontawesome-free-6.5.1-web/css/all.min.css';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

/*root.render(<App />);*/
